var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('validation-observer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('b-form',{on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.submitValidatedNoteLocal)}}},[_c('form-note',{attrs:{"note":_vm.note}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }